import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isClosed, getShopFullAddress } from '@utils/shop';
import useShopHeaderImage from '@hooks/images/useShopHeaderImage';
import MenuSearchInput from '@conversion/containers/MenuSearchInput';
import { ORIGIN_POSITION } from '@shopDetails/tracking/actions/trackShopInfoClicked';
import SubHeaderSeparator from '@components/SubHeaderSeparator';
import Notification from '../../Notification';
import BackgroundImage from '../../BackgroundImage';
import ShopInformation from '../../ShopInformation';
// Old styles
import {
  Container,
  Separator,
  ShopHeaderContainer,
  Gradient,
  Body,
  ItemsContainer,
  Name,
  NameContainer,
  SubHeaderContainer,
} from '../../MainHeaderRestaurant/Desktop/components';
// New styles
import { LinkShopInfo, ArrowRight } from './components';
import HeaderShimmer from './components/HeaderShimmer';

const HEADER_HEIGHT = 230;

function MainHeaderRestaurantPickup({
  shop,
  reviewsRoute,
  shopInfoRoute,
  show,
  showInputSearch,
  onSearchClick,
  searchPlaceholder,
  subHeader,
  children,
  trackShopInfoClicked,
  discountsTotalAmount,
  plusSettings,
  shippingAmount,
  showShimmer,
}) {
  const backgroundImage = useShopHeaderImage(shop);
  const currentAddress = useMemo(() => getShopFullAddress(shop), [shop]);

  const trackShopInfoClick = useCallback(
    () => trackShopInfoClicked({ origin: ORIGIN_POSITION.ADDRESS }),
    [trackShopInfoClicked],
  );

  if (showShimmer) {
    return <HeaderShimmer isPickup />;
  }

  return (
    <Container show={show}>
      <ShopHeaderContainer height={HEADER_HEIGHT}>
        <BackgroundImage
          src={backgroundImage}
          isClosed={isClosed(shop)}
          height="100%"
        />
        <Gradient />
        <Body height={HEADER_HEIGHT}>
          <Separator />
          <ItemsContainer>
            <NameContainer>
              {Boolean(shop?.name) && <Name>{shop.name}</Name>}
              {currentAddress && (
                <LinkShopInfo to={shopInfoRoute} onClick={trackShopInfoClick}>
                  {currentAddress}
                  <ArrowRight size="xsmall" color="white" />
                </LinkShopInfo>
              )}
              <ShopInformation
                isDesktop
                isPickup
                shop={shop}
                reviewsRoute={reviewsRoute}
                discountsTotalAmount={discountsTotalAmount}
                plusSettings={plusSettings}
                shippingAmount={shippingAmount}
              />
            </NameContainer>
            {showInputSearch && (
              <MenuSearchInput
                onClick={onSearchClick}
                placeholder={searchPlaceholder}
                disabled
                background="primary"
              />
            )}
          </ItemsContainer>
        </Body>
      </ShopHeaderContainer>
      {subHeader && <SubHeaderContainer>{subHeader}</SubHeaderContainer>}
      {subHeader && <SubHeaderSeparator />}
      <Notification shop={shop} showDiscount={false} />
      {children}
    </Container>
  );
}

MainHeaderRestaurantPickup.propTypes = {
  show: PropTypes.bool,
  shop: PropTypes.object.isRequired,
  reviewsRoute: PropTypes.string.isRequired,
  shopInfoRoute: PropTypes.string.isRequired,
  onSearchClick: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  subHeader: PropTypes.node,
  children: PropTypes.node,
  showInputSearch: PropTypes.bool,
  trackShopInfoClicked: PropTypes.func.isRequired,
  discountsTotalAmount: PropTypes.number,
  plusSettings: PropTypes.object,
  shippingAmount: PropTypes.number,
  showShimmer: PropTypes.bool,
};

MainHeaderRestaurantPickup.defaultProps = {
  show: true,
  searchPlaceholder: '',
  showInputSearch: true,
  showShimmer: false,
  onSearchClick: () => {},
};

export default MainHeaderRestaurantPickup;
